import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '關於琮恩', path: '/about' },
  { label: '服務項目', path: '/services' },
  { label: '知識分享', path: '/knowledge' },
  { label: '客戶見證', path: '/testimonials' },
  { label: '工具資源', path: '/tools' },
  { label: '常見問答', path: '/faq' },
  { label: '聯絡我們', path: '/contact' },
];

const serviceLinks = [
  { label: '個人醫療保險', path: '/services' },
  { label: '家庭保障規劃', path: '/services' },
  { label: '資產與風險管理', path: '/services' },
  { label: '企業與團體方案', path: '/services' },
  { label: '保單健檢服務', path: '/tools' },
];

export default function Footer() {
  return (
    <footer className="bg-[#2E2A3B] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/38f658e8-fef2-49e2-8ee9-ab4cf6df771d.png"
                alt="保險建築師 Logo"
                className="h-14 w-auto object-contain brightness-0 invert"
              />
              <h3 className="font-bold text-white" style={{ fontSize: '1.375rem' }}>
                保險建築師
              </h3>
            </div>
            <p className="text-white/70 leading-relaxed mb-2" style={{ fontSize: '1.0625rem', lineHeight: '1.75' }}>
              守護健康，保障未來
            </p>
            <p className="text-white/55 mb-6" style={{ fontSize: '1rem', lineHeight: '1.7' }}>
              用建築師的精神，為每一位客戶打造堅固的保障藍圖。專業、誠信、長期陪伴，是我們對您的承諾。
            </p>
            <div className="flex gap-3">
              {[
                { href: 'https://lin.ee/6XFYSq2', icon: 'ri-line-fill', label: 'LINE' },
                { href: '#', icon: 'ri-facebook-fill', label: 'Facebook' },
                { href: '#', icon: 'ri-instagram-line', label: 'Instagram' },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#D4A373] transition-colors duration-200 cursor-pointer"
                  aria-label={s.label}
                >
                  <i className={`${s.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-[#D4A373] mb-5" style={{ fontSize: '1.0625rem' }}>
              快速連結
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/65 hover:text-[#D4A373] transition-colors duration-200"
                    style={{ fontSize: '1rem' }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-[#D4A373] mb-5" style={{ fontSize: '1.0625rem' }}>
              服務項目
            </h4>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-white/65 hover:text-[#D4A373] transition-colors duration-200"
                    style={{ fontSize: '1rem' }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-[#D4A373] mb-5" style={{ fontSize: '1.0625rem' }}>
              聯絡資訊
            </h4>
            <ul className="space-y-4">
              {[
                { icon: 'ri-phone-line', text: '04-1234-5678（暫用）' },
                { icon: 'ri-mail-line', text: 'info@insurancearchitect.com' },
                { icon: 'ri-line-fill', text: 'LINE@：@031gzncd' },
                { icon: 'ri-time-line', text: '週一至週五 09:00–18:00' },
                { icon: 'ri-map-pin-line', text: '台灣全區，提供線上諮詢' },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className={`${item.icon} text-[#D4A373]`}></i>
                  </div>
                  <span className="text-white/65" style={{ fontSize: '1rem', lineHeight: '1.6' }}>{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-white/10 pt-8 mb-6">
          <p className="text-white/40" style={{ fontSize: '1rem', lineHeight: '1.75' }}>
            <strong className="text-white/55">免責聲明：</strong>
            本網站所有內容僅供參考，不構成任何保險商品之要約或承諾。實際保障內容、保費、核保條件與理賠規定，仍需依各保險公司保單條款及相關法規為準。本網站不保證任何保險商品之承保、理賠或獲利結果。如需正式保障規劃，請洽詢持照保險業務員進行個別評估。
          </p>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-4 border-t border-white/8">
          <p className="text-white/40 text-center sm:text-left" style={{ fontSize: '1rem' }}>
            © 2026 保險建築師 陳琮恩. All rights reserved.
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <button
              className="text-white/40 hover:text-white/70 transition-colors duration-200 cursor-pointer"
              style={{ fontSize: '1rem' }}
              onClick={() => alert('隱私權政策頁面建置中，敬請期待。')}
            >
              隱私權政策
            </button>
            <span className="text-white/20">|</span>
            <button
              className="text-white/40 hover:text-white/70 transition-colors duration-200 cursor-pointer"
              style={{ fontSize: '1rem' }}
              onClick={() => alert('免責聲明已顯示於頁面底部。')}
            >
              免責聲明
            </button>
            <span className="text-white/20">|</span>
            <p className="text-white/35" style={{ fontSize: '1rem' }}>
              專業保險規劃 · 量身打造 · 長期陪伴
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
